import { createElement, unsafelyCreateElementFromString } from './mithril';
import * as embeddedComponents from './embeddedComponents';
import { isPrimitiveRegion } from './BasePrototype/RegionHandling';
var MithrilHelpers = /** @class */ (function () {
    function MithrilHelpers(component) {
        this.unsafelyCreateElementFromString = unsafelyCreateElementFromString;
        this.createComponent = embeddedComponents.createComponent;
        this.component = component;
    }
    MithrilHelpers.prototype.region = function (name, tagName, attributes) {
        if (tagName === void 0) { tagName = 'div'; }
        if (attributes === void 0) { attributes = {}; }
        var region = this.component.getRegion(name);
        // If there are no contents for the region, do not generate any DOM.
        // Make sure that we handle the number zero correctly, similar to what
        // we did in the React wrapper: https://code.amazon.com/reviews/CR-2977382
        if (!region && typeof region !== 'number') {
            return;
        }
        var regionAttribute = this.component.__componentName + "-region";
        attributes[regionAttribute] = name;
        // For primitive regions, we can be done at this point.
        if (isPrimitiveRegion(region)) {
            return createElement(tagName, attributes, region);
        }
        // For node-based regions, we have to append the DOM node at the end.
        // Add oncreate callback that will attach the right region node
        // when instantiated
        var setRegionNode = function (element) {
            // Check if the right region is already there
            if (element.childNodes[0] === region) {
                return;
            }
            // Not the right region, reset and add region
            element.innerHTML = '';
            element.appendChild(region);
        };
        attributes.lifecycleKey = regionAttribute + "-" + name;
        attributes.componentDidMount = setRegionNode;
        attributes.componentDidUpdate = setRegionNode;
        attributes.componentWillUnmount = function () {
            var parent = region.parentElement;
            if (parent) {
                parent.removeChild(region);
            }
        };
        return createElement(tagName, attributes);
    };
    /*
     * Returns an object containing the named properties from the supplied object.
     * Omits properties with a value of undefined.  If no named properties are
     * supplied, Object.keys(object) is used.
     */
    MithrilHelpers.prototype.copyDefined = function (object, propertyNames) {
        if (propertyNames === undefined) {
            propertyNames = Object.keys(object);
        }
        function copyDefinedPropertyValue(objectCopy, propertyName) {
            var propertyValue = object[propertyName];
            if (typeof propertyValue !== 'undefined') {
                objectCopy[propertyName] = propertyValue;
            }
            return objectCopy;
        }
        return propertyNames.reduce(copyDefinedPropertyValue, {});
    };
    return MithrilHelpers;
}());
export default MithrilHelpers;
//# sourceMappingURL=MithrilHelpers.js.map